export const SET_AUTH = 'setUser'
export const SET_LOCALSTORE = 'seTLocalstore'

export const PURGE_AUTH = 'logOut'
export const SET_ERROR = 'setError'

export const SET_DB_TABLES = 'setDbTables'
export const SET_DB_TABLE =  'setDbTable'

export const SET_SIDEBAR = 'SET_SIDEBAR'
export const SET_SHOW_SIDEBAR =  'SET_SHOW_SIDEBAR'


// WEBPACK FOOTER //
// ./src/store/mutations.type.js